/* unplugin-vue-components disabled */import script from "./goods.vue?vue&type=script&setup=true&lang=js"
export * from "./goods.vue?vue&type=script&setup=true&lang=js"

import "./goods.vue?vue&type=style&index=0&id=0a6fb0e9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a6fb0e9"]])

export default __exports__